import { memo } from "react";
import { PLAYER_HEIGHT, PLAYER_WIDTH } from "./constants";
import { Box } from "./react-graphics";

type Props = {
  x: number;
  y: number;
};

const Player = ({ x, y }: Props) => {
  return (
    <Box
      x={x}
      y={-y}
      width={PLAYER_WIDTH}
      height={PLAYER_HEIGHT}
      fillColor={0x000000}
      pivotX={0.5}
      pivotY={0.5}
    />
  );
};

export default memo(Player);
